import { Link } from 'react-router-dom';
import { Shield, CheckCircle, Package, Building } from 'lucide-react';

const indicators = [
  {
    icon: Shield,
    text: 'Tus datos están protegidos',
    link: '/politica-de-privacidad',
  },
  {
    icon: CheckCircle,
    text: 'Campañas verificadas por nuestro equipo',
    link: '/acerca-de',
  },
  {
    icon: Package,
    text: 'Donaciones en especie, sin intermediarios de dinero',
    link: '/faq',
  },
  {
    icon: Building,
    text: 'Empresa registrada legalmente',
    link: '/terminos-y-condiciones',
  },
];

export function TrustIndicators() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="border-t border-b border-gray-200 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {indicators.map(({ icon: Icon, text, link }) => (
            <Link
              key={text}
              to={link}
              className="flex items-center space-x-3 group"
            >
              <div className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-indigo-50 transition-colors">
                <Icon className="w-4 h-4 text-gray-600 group-hover:text-indigo-600 transition-colors" />
              </div>
              <span className="text-sm text-gray-600 group-hover:text-gray-900 transition-colors">
                {text}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
